import useStatefulTabs from "./useStatefulTabs";

export default function useGoToNextTab<T>(): () => void {
    const { activeTab, setActiveTab } = useStatefulTabs<T>();
    return () => {
        setActiveTab(activeTab + 1);
    };
}
